var map = {
	"./slide10.jpg": 1229,
	"./slide11.jpg": 9984,
	"./slide12.jpg": 3711,
	"./slide13.jpg": 2002,
	"./slide14.jpg": 7233,
	"./slide15.jpg": 9076,
	"./slide6.jpg": 6082,
	"./slide66.jpg": 8390,
	"./slide7.jpg": 7791,
	"./slide8.jpg": 9420,
	"./slide88.jpg": 9062,
	"./slide9.jpg": 4121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7754;